import React from 'react';
import { Box, IconButton, Menu, MenuItem, Badge, Avatar, Tooltip, Stack, Grid } from '@mui/material';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import "../layouts/Layouts.css";
import NotificationHome from '../components/Pages/Notification/NotificationHome';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { ChangePassword } from "./index";
import { useNavigate } from 'react-router';

function Profilemenu() {
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [passwordPopup, setPasswordPopup] = React.useState(false)

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";

  const handleLogout = () => {
    localStorage.removeItem("argus_user");
    navigate("/")
    // window.location.reload()
  }
  const handlePassword = () => {
    if (passwordPopup) {
      setPasswordPopup(false)
    }
    else {
      setPasswordPopup(true)
    }
  }
  return (
    <Box sx={{ flexGrow: 6 }} className="argus-avtar">
      <Stack
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
      // spacing={1}
      >
        <Grid>
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <Avatar className='avtar-main' alt={isUserLogged.username} src="" />
            <h3 className='avtar-name'>Welcome {isUserLogged.username}
              <span>{open ? <ArrowDropUpIcon fontSize='small' /> : <ArrowDropDownIcon fontSize='small' />}</span></h3>
          </IconButton>
        </Grid>

        {/* <Grid sx={{ cursor: "pointer" }} onClick={handleClick}>
          <h3 className='avtar-name'>Welcome {isUserLogged.username}
        <span>{open?<ArrowDropUpIcon fontSize='small'/>:<ArrowDropDownIcon fontSize='small'/>}</span></h3></Grid>
         */}

        <Grid><NotificationHome /></Grid>

        {/* <Grid>
                <Tooltip  title="Logout">
                  <IconButton  edge="end"  sx={{float:"right",color:"white"}} onClick={()=>handleLogout()}>
                    <PowerSettingsNewIcon/>
                  </IconButton>
                </Tooltip>
                </Grid> */}
      </Stack>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        className="profile-menu"
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: .5,
            '& .MuiAvatar-root': {
              width: 20,
              height: 20,
              ml: 1.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem className='profile-menu' onClick={() => handlePassword()}>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Change Password
        </MenuItem>
        <MenuItem className='profile-menu' onClick={() => handleLogout()}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
      <ChangePassword handlePasswordPopup={handlePassword} open={passwordPopup} id={isUserLogged.userid} />

    </Box>

  )
}
export default Profilemenu;